/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ConfluenceEdition {
  FREE = "FREE",
  PREMIUM = "PREMIUM",
  STANDARD = "STANDARD",
}

export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentRestrictionsQuery
// ====================================================

export interface ContentRestrictionsQuery_content_nodes_operations {
  operation: string | null;
  targetType: string | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_profilePicture {
  path: string;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_restrictingContent_links {
  webui: string | null;
  base: string | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_restrictingContent {
  id: string | null;
  links: ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_restrictingContent_links | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes {
  type: string | null;
  displayName: string | null;
  accountId: string | null;
  profilePicture: ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_profilePicture | null;
  hasSpaceViewPermission: boolean | null;
  hasSpaceEditPermission: boolean | null;
  permissionType: SitePermissionType | null;
  restrictingContent: ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_restrictingContent | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions {
  count: number | null;
  nodes: (ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes | null)[] | null;
  pageInfo: ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_pageInfo | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_group_nodes {
  id: string | null;
  name: string | null;
  permissionType: SitePermissionType | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_group_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_group {
  count: number | null;
  nodes: (ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_group_nodes | null)[] | null;
  pageInfo: ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_group_pageInfo | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions {
  userWithRestrictions: ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions | null;
  group: ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions_group | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_read {
  restrictions: ContentRestrictionsQuery_content_nodes_restrictions_read_restrictions | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_profilePicture {
  path: string;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_restrictingContent_links {
  webui: string | null;
  base: string | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_restrictingContent {
  id: string | null;
  links: ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_restrictingContent_links | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes {
  type: string | null;
  displayName: string | null;
  accountId: string | null;
  profilePicture: ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_profilePicture | null;
  hasSpaceViewPermission: boolean | null;
  hasSpaceEditPermission: boolean | null;
  permissionType: SitePermissionType | null;
  restrictingContent: ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_restrictingContent | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions {
  count: number | null;
  nodes: (ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes | null)[] | null;
  pageInfo: ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_pageInfo | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_group_nodes {
  id: string | null;
  name: string | null;
  permissionType: SitePermissionType | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_group_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_group {
  count: number | null;
  nodes: (ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_group_nodes | null)[] | null;
  pageInfo: ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_group_pageInfo | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions {
  userWithRestrictions: ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions | null;
  group: ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions_group | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions_update {
  restrictions: ContentRestrictionsQuery_content_nodes_restrictions_update_restrictions | null;
}

export interface ContentRestrictionsQuery_content_nodes_restrictions {
  read: ContentRestrictionsQuery_content_nodes_restrictions_read | null;
  update: ContentRestrictionsQuery_content_nodes_restrictions_update | null;
}

export interface ContentRestrictionsQuery_content_nodes_space {
  id: string | null;
  containsExternalCollaborators: boolean;
}

export interface ContentRestrictionsQuery_content_nodes {
  id: string | null;
  hasInheritedRestrictions: boolean;
  hasRestrictions: boolean;
  hasViewRestrictions: boolean;
  title: string | null;
  type: string | null;
  operations: (ContentRestrictionsQuery_content_nodes_operations | null)[] | null;
  restrictions: ContentRestrictionsQuery_content_nodes_restrictions | null;
  space: ContentRestrictionsQuery_content_nodes_space | null;
}

export interface ContentRestrictionsQuery_content {
  nodes: (ContentRestrictionsQuery_content_nodes | null)[] | null;
}

export interface ContentRestrictionsQuery_tenant_editions {
  edition: ConfluenceEdition;
}

export interface ContentRestrictionsQuery_tenant {
  editions: ContentRestrictionsQuery_tenant_editions | null;
}

export interface ContentRestrictionsQuery {
  content: ContentRestrictionsQuery_content | null;
  tenant: ContentRestrictionsQuery_tenant;
}

export interface ContentRestrictionsQueryVariables {
  contentId: string;
  status?: (string | null)[] | null;
  readUserStart?: number | null;
  readGroupStart?: number | null;
  editUserStart?: number | null;
  editGroupStart?: number | null;
}
